import { render } from "./Ribbon.vue?vue&type=template&id=75601d4e&scoped=true"
const script = {}

import "./Ribbon.vue?vue&type=style&index=0&id=75601d4e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75601d4e"]])

export default __exports__